import { useMemo } from 'react';

const usePropertyTag = (form) => {
  const { categoryList, productPropertyList } = form.getFieldsValue();
  return useMemo(() => {
    // 카테고리 리스트를 속성 태그 값으로 맵핑
    const categoryArray = categoryList.reduce((acc, item) => {
      const tempArr = [];
      tempArr.push({ id: item.id, name: item.name });
      item.subCategory.forEach((item) => {
        tempArr.push({ id: item.id, name: item.name });
      });
      return [...acc, ...tempArr];
    }, []);

    // 상품 속성을 속성 태그 값으로 맵핑
    const propertyArray = [];
    for (const key in productPropertyList) {
      propertyArray.push(...productPropertyList[key].list);
    }

    // 중복 제거
    const tempSet = new Set([...categoryArray, ...propertyArray].map((item) => item.name));
    const uniqValue = [...tempSet].map((name, id) => ({ id, name }));
    return uniqValue;
  }, [categoryList, productPropertyList]);
};

export default usePropertyTag;
